import { render, staticRenderFns } from "./ItemsTypeSwitch.vue?vue&type=template&id=61c6f007&scoped=true&"
import script from "./ItemsTypeSwitch.vue?vue&type=script&lang=ts&"
export * from "./ItemsTypeSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsTypeSwitch.vue?vue&type=style&index=0&id=61c6f007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c6f007",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
